import { webAPIUrl } from "./AppSettings";

export interface HttpRequest<REQB> {
  path: string;
  method?: string;
  body?: REQB;
  accessToken?: string;
  headers?: HeadersInit;
  noResponsebody?: boolean;
}
export interface HttpResponse<RESB> {
  ok: boolean;
  body?: RESB;
  statusCode?: number;
}

export const http = async <RESB, REQB = undefined>(
  config: HttpRequest<REQB>
): Promise<HttpResponse<RESB>> => {
  const request = new Request(`${webAPIUrl}${config.path}`, {
    method: config.method || "get",
    headers: config.headers || {
      "Content-Type": "application/json",
    },
    body: config.body ? JSON.stringify(config.body) : undefined,
  });
  if (config.accessToken) {
    request.headers.set("authorization", `bearer ${config.accessToken}`);
  }
  try {
    const response = await fetch(request);
    if (response.ok) {
      if (response.headers.has("RefreshToken")) {
        sessionStorage.setItem("auth", response.headers.get("RefreshToken")!);
      }
      if (config.noResponsebody) {
        return { ok: response.ok };
      } else {
        const body = await response.json();
        return { ok: response.ok, body };
      }
    } else {
      if (response.status === 401) {
        window.location.replace(window.location.origin);
        return { ok: false };
      }
      // logError(request, response);
      try {
        const body = await response.json();
        return {
          ok: response.ok,
          statusCode: response.status,
          body: body,
        };
      } catch (error) {
        // console.error(error);
        return {
          ok: response.ok,
          statusCode: response.status,
        };
      }
    }
  } catch (error) {
    console.error(
      `Error requesting ${request.method}
    ${request.url}`,
      error
    );
    return { ok: false };
  }
};

export const httpForm = async <RESB, REQB = undefined>(
  config: HttpRequest<REQB>,
  formBody: FormData
): Promise<HttpResponse<RESB>> => {
  const request = new Request(`${webAPIUrl}${config.path}`, {
    method: config.method || "get",
    body: formBody,
  });
  if (config.accessToken) {
    request.headers.set("authorization", `bearer ${config.accessToken}`);
  }
  try {
    const response = await fetch(request);
    if (response.ok) {
      const body = await response.json();
      return { ok: response.ok, body };
    } else {
      if (response.status === 401) {
        window.location.replace(window.location.origin);
        return { ok: false };
      }
      // logError(request, response);
      try {
        const body = await response.json();
        return {
          ok: response.ok,
          statusCode: response.status,
          body: body,
        };
      } catch (error) {
        // console.error(error);
        return {
          ok: response.ok,
          statusCode: response.status,
        };
      }
    }
  } catch (error) {
    console.error(
      `Error requesting ${request.method}
    ${request.url}`,
      error
    );
    return { ok: false };
  }
};

export const httpForBlob = async <REQB = undefined>(
  config: HttpRequest<REQB>
): Promise<Blob> => {
  const request = new Request(`${webAPIUrl}${config.path}`, {
    method: config.method || "get",
    headers: config.headers || {
      "Content-Type": "application/json",
    },
    body: config.body ? JSON.stringify(config.body) : undefined,
  });
  if (config.accessToken) {
    request.headers.set("authorization", `bearer ${config.accessToken}`);
  }
  try {
    const response = await fetch(request);
    if (response.ok) {
      return response.blob();
    } else {
      if (response.status === 401) {
        window.location.replace(window.location.origin);
      }
      return new Blob();
    }
  } catch (error) {
    console.error(
      `Error requesting ${request.method}
    ${request.url}`,
      error
    );
    return new Blob();
  }
};

// const logError = async (request: Request, response: Response) => {
//   const contentType = response.headers.get("content-type");
//   let body: any;
//   if (contentType && contentType.indexOf("application/json") !== -1) {
//     body = await response.json();
//   } else {
//     body = await response.text();
//   }
//   console.error(
//     `Error requesting ${request.method}
//     ${request.url}`,
//     body
//   );
// };
